<template>
    <div class="row">
        <div class="col-12">
            <div class="section-title-area">
                <h2 class="section-heading">{{ pageTitle }} <span class="d-block"></span></h2>
                <p class="section-subheading" v-if="pageSubheading">{{ pageSubheading }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        subHeading: String
    },
    data(){
        return {
            pageTitle: '',
            pageSubheading: ''
        }
    },
    watch: {
        'title'(){
            this.pageTitle = this.$props.title
        },
        'subHeading'(){
            this.pageSubheading = this.$props.subHeading
        }
    }
}
</script>